module.exports = __webpack_public_path__ + "img/f_p2_sweetdream.042780dc.jpg";